/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './Intro.module.scss';
import logo from '../../Resources/logogames.png';
import appStore from '../../Resources/appstore.svg';
import gplay from '../../Resources/gplay.svg';

const Intro = () => {
  const { t } = useTranslation();

  return (
    <div className={s.container}>
      <div className={s.top}>
        <div className={s.left}>
          <h1>PROVER Games</h1>
          <p>{t('intro')}</p>
        </div>
        <img src={logo} alt="Prover Games" />
      </div>
      <div className={s.apps}>
        <h2>{t('install_app')}</h2>
        <div className={s.items}>
          <a href="https://itunes.apple.com/us/app/prover-swype-id/id1420462547">
            <img src={appStore} alt="App Store" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=io.prover.swypeid">
            <img src={gplay} alt="Google Pay" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Intro;
